import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setContent } from "@/store/cart/cartSlice"
import { Card, CardHeader, CardContent, CardTitle } from "@/components/ui/card";

const Instructions = () => {
  const dispatch = useDispatch();
  const content = useSelector((state) => state.cart.content);
  const [ currentInstruction, setCurrentInstruction ] = useState(content);

  const handleChange = (e) => {
    setCurrentInstruction(e.target.value);
  }

  const onBlur = () => dispatch(setContent(currentInstruction))
  
  return (
    <section>
      <Card
        className="
            w-full border-0 overflow-hidden 
            relative sans relative rounded-none 
            py-10 px-6
          "
      >
        <CardHeader className="space-y-0 px-0 py-0">
          <CardTitle>Add Instructions to Order</CardTitle>
        </CardHeader>
        <CardContent className="px-0 py-0 mt-3">
          <textarea
            className="
              p-2 border border-[#bdbdbd]
              text-font-primaryMuted min-h-[100px] w-full 
              hover:outline-none rounded-none focus:outline-none
              placeholder:text-slate-400
              placeholder:text-sm placeholder:tracking-wide 
            "
            value={currentInstruction}
            onChange={handleChange}
            onBlur={onBlur}
          />
        </CardContent>
      </Card>
    </section>
  )
}

export default Instructions